<template>
  <div class="EPexplorer">
    <div class="EPexplorer-inner">
      <div class="HeatmapTitle">Expression Pattern explorer</div>
      <!-- 表单搜索区 -->
      <el-row :gutter="20">
        <el-col :span="6">
          <p class="top_p">Species：
            <i>{{heatmap_form.specie}}</i>
          </p>
        </el-col>
        <el-col :span="6">
          <p class="top_p">SRA Study：
            <span>{{heatmap_form.sra_study}}</span>
          </p>
        </el-col>
        <el-col :span="6">
          <p class="top_p">Input lncRNA Number：
            <span>{{heatmap_form.lncRNA_num}}</span>
          </p>
        </el-col>
        <el-col :span="6">
          <p class="top_p">Matched lncRNA Number：
            <span>{{heatmap_form.LncRNA_metched_num}}</span>
          </p>
        </el-col>
      </el-row>
      <!-- 多级表格 -->
      <i class="el-icon-download" style="padding-bottom:14px;" @click="DownloadTableTxt"> Download TXT</i>
      <el-table :data="tableData.slice((query.page-1)*query.size,query.page*query.size)" class="table" v-loading="loading" ref="multipleTable"
        stripe header-cell-class-name="table-header" :header-cell-style="headerStyle" :row-style="rowStyle" @cell-click="handlecell"
        :cell-style="cellstyle" border>
        <el-table-column :width="idColumnWidth" prop="LncRNA_ID" align="center" fixed="left" :show-overflow-tooltip="true" label="lncRNA ID">
        </el-table-column>
        <el-table-column :label="items.label" align="center" v-for="(items, indexs) in tableDataItem" :key="indexs">
          <el-table-column v-if="item !=='LncRNA_ID'" v-for="(item, index) in items.column" :width="columnWidth" :key="index" :prop="item.prop"
            align="center" :show-overflow-tooltip="true" :label="item.label">
          </el-table-column>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="query.page"
          :page-sizes="[10, 20, 30, 50]" :page-size="query.size" layout="total, sizes, prev, pager, next" :total="pageTotal">
        </el-pagination>
      </div>
      <!-- 热力图 -->
      <div style="width: 1200px; margin: 40px auto;">
        <div v-for="(item, index) in imgUrlItems" :key="index">
          <p class="keyword_p1">{{item.label}}
            <i class="el-icon-download" @click="DownloadSvg(item.cluster_url)"> Download SVG</i>
          </p>
          <img :src="item.cluster_url" alt="" width='1200px'>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 表格
      tableDataItem: [],
      tableData: [],
      loading: false,
      pageTotal: 0,
      query: {
        page: 1,
        size: 10
      },
      headerStyle: {
        background: "#F5F9FC",
        fontSize: "16px",
        fontFamily: "PingFang SC",
        fontWeight: "bold",
        color: "#333"
      },
      rowStyle: {
        fontSize: "14px",
        fontFamily: "PingFang SC",
        fontWeight: "400",
        color: "#666"
      },
      // 表单
      heatmap_form: {
        specie: '',
        sra_study: '',
        lncRNA_num: 0,
        LncRNA_metched_num: 0
      },
      imgUrlItems: [],
      columnWidth: 120,
      idColumnWidth: 160
    };
  },
  mounted() {
    this.getData()
  },
  methods: {
    // 表格
    getData() {
      let heatmapData = JSON.parse(sessionStorage.getItem("heatmapData"))
      let heatmapParams = JSON.parse(sessionStorage.getItem("heatmapParams"))
      this.heatmap_form.specie = heatmapParams.specie.replace(/_/g, ' ');
      this.heatmap_form.sra_study = heatmapParams.sra_study
      this.loading = true
      this.tableDataItem = []
      if (heatmapData.code == 200) {
        this.imgUrlItems = heatmapData.img_list
        this.loading = false
        let count = 1
        heatmapData.header.forEach((items, index) => {
          this.tableDataItem.push({
            label: items.sra_study,
            column: []
          })
          items.columns_values.forEach(item => {
            if (item != 'LncRNA_ID') {
              this.tableDataItem[index].column.push({
                prop: item,
                label: item.split('_')[item.split('_').length - 1]
              })
              count++
            }
          })
        })
        if (count > 9) {
          this.columnWidth = 120
          this.idColumnWidth = 160
        } else {
          this.columnWidth = 'auto'
          this.idColumnWidth = 'auto'
        }
        this.tableData = heatmapData.data
        this.pageTotal = heatmapData.all_count;
        this.heatmap_form.LncRNA_metched_num = heatmapData.LncRNA_metched_num;
        this.heatmap_form.lncRNA_num = heatmapData.input_LncRNA_num;
      } else {
        this.$message.warning(heatmapData.msg);
      }
    },
    handleSizeChange(val) {
      this.query.page = 1
      this.query.size = val
    },
    handleCurrentChange(val) {
      this.query.page = val
      // this.getData()
    },
    handlecell(row, col) {
      if (col.label === "lncRNA ID") {
        sessionStorage.removeItem("lncRNA_id");
        sessionStorage.setItem("lncRNA_id", row.LncRNA_ID);
        // this.$router.push("/nunMir");
        this.$router.push({
          path: '/nunMir',
          query: {
            plncdb_id: row.LncRNA_ID
          }
        })
      }
    },
    cellstyle({ row, column, rowIndex, columnIndex }) {
      if (column.label === 'lncRNA ID') {
        return { color: "#3366CC", cursor: "pointer" }
      }
      if (column.label === 'Species') {
        return {
          fontStyle: 'italic'
        }
      }
    },
    DownloadSvg(downloadUrl) {
      const param = {
        cluster_url: downloadUrl,
        tag: 'svg'
      }
      this.jg_downloadFile('species/download_svg_heatmap', param)
    },
    DownloadTableTxt() {
      const param = {
        cluster_url: JSON.parse(sessionStorage.getItem("heatmapData")).download_txt_url,
        tag: 'txt'
      }
      this.jg_downloadFile('species/download_svg_heatmap', param)
    }
  }
};
</script>

<style scoped>
.EPexplorer {
  width: 100%;
  padding: 30px 0px;
  background: #f5f9fc;
}
.EPexplorer .EPexplorer-inner {
  width: 1240px;
  height: auto;
  padding: 0px 20px;
  padding-bottom: 20px;
  margin: 0 auto;
  background: rgba(255, 255, 255, 1);
}
.EPexplorer .EPexplorer-inner .HeatmapTitle {
  height: 50px;
  font-size: 30px;
  font-family: PingFang SC;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  line-height: 50px;
  border-bottom: 1px solid rgba(229, 233, 235, 1);
  margin-bottom: 20px;
}
.svgClass {
  margin-top: 20px;
  width: 100%;
  height: 750px;
  /* height: 916px; */
}
.el-pagination {
  /* float: right; */
  text-align: right;
  height: 20px;
  margin: 20px 0;
}
.el-icon-download {
  float: right;
  color: rgb(139, 182, 68);
  font-size: 14px;
  cursor: pointer;
  padding-top: 8px;
  padding-left: 20px;
}
.metchedNum {
  color: #999;
  font-size: 18px;
  font-weight: bold;
  padding-left: 10px;
  line-height: 28px;
  display: inline-block;
  padding-top: 6px;
  width: 266px;
  white-space: nowrap;
}
.top_p {
  height: 18px;
  font-size: 18px;
  font-family: PingFang SC Medium, PingFang SC Medium-Medium;
  font-weight: 500;
  color: #333333;
  line-height: 28px;
  white-space: nowrap;
}
.top_p span {
  color: #666;
  font-size: 16px;
}
</style>
